import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Agenda} from '../models/agenda';
import {InviteV2} from '../models/invite-v2';
import {MatTableDataSource} from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {CryptoService} from './crypto.service';
import {Member} from '../models/member';
import {EmailService} from './email.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {ContextService} from './context.service';

@Injectable({
  providedIn: 'root'
})
export class InviteSpeakersService {

  public waiting: any;

  public invitesDataSource: MatTableDataSource<any>;
  public invitesDisplayColumns: string[] = [ 'staff_name', 'confirm', 'date_sent', 'date_response', 'accept', 'delete', 'edit', 'select' ];

  public responsesDataSource: MatTableDataSource<any>;
  public responsesArchivedDataSource: MatTableDataSource<any>;

  public reponsesDisplayColumns: string[] = [ 'member_name_response', 'edit' ];

  constructor (
    private db: AngularFirestore,
    private snackBar: SnackBarIconService,
    private _contextService: ContextService,
    private _cryptoService: CryptoService,
    public _emailService: EmailService,
    private _spinnerService: SpinnerService,
  ) {

  }

  getById (id) {
    return this.db.doc<InviteV2>('sbccv_invites_v2/' + id)
      .get();
  }

  async registerResponse (invite_id: any, updatedData: any) {
    try {
      await this.db.collection('sbccv_invites_v2').doc(invite_id)
        .set(Object.assign({}, updatedData), {merge: true});
      this.snackBar.openSnackBar("Sucesso!", '', 'success');
    } catch (error) {
      console.log("ERRO " + JSON.stringify(error));
      this.snackBar.openSnackBar("erro registerResponse", '', 'error');
    }
  }

  selectInvites (context_id) {
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where("context_id", "==", context_id)
      .orderBy('member_name', 'asc')).get();
  }

  /*
  async _loadAgenda (isCongress: boolean, context_id: any) {
    this.waiting = this._spinnerService.show();
    const events = await this._contextService.getEventsInContext(isCongress, context_id);
    const agendaRaw = await this.getAgenda(events);
    const agenda = await this.formatAgenda(agendaRaw);
    return agenda;
  }
    */

  async getAgenda (events: string[]): Promise<Agenda[]> {
    const waiting = this._spinnerService.show();
    try {
      const agendas: Agenda[] = [];
      // Usar Promise.all para executar todas as consultas em paralelo
      const querySnapshots = await Promise.all(
        events.map(event_id =>
          this.db.collection<Agenda>('sbccv_agenda', ref => ref
            .where('event_id', '==', event_id)
            .orderBy('member_name', 'asc'))
            .get()
            .toPromise()
        )
      );

      // Iterar sobre cada querySnapshot e adicionar os documentos ao array agendas
      querySnapshots.forEach(querySnapshot => {
        querySnapshot.forEach(doc => {
          const agenda:  any = {} //new Agenda();
          agenda.id = doc.id;
          agenda.requireConfirm = doc.data().requireConfirm;
          agenda.acceptInvite = false;
          agenda.member_id = doc.data().member_id;
          agenda.member_name = doc.data().member_name;
          agenda.event_id = doc.data().event_id;
          agenda.event_name = doc.data().event_name;
          agenda.day_id = doc.data().day_id;
          agenda.day_date = doc.data().day_date;
          agenda.day_date_string = this.formatDate(doc.data().day_date);
          agenda.day_name = doc.data().day_name;
          agenda.depto_id = doc.data().depto_id;
          agenda.depto_name = doc.data().depto_name;
          agenda.activity_id = doc.data().activity_id;
          agenda.activity_name = doc.data().activity_name;
          agenda.activity_startTime = doc.data().activity_startTime;
          agenda.level = doc.data().level;

          if (agenda.level === "t") {
            agenda.topic_id = doc.data().topic_id;
            agenda.topic_name = doc.data().topic_name;
            agenda.topic_startTime = doc.data().topic_startTime;
            agenda.topic_duration = doc.data().topic_duration;
          }

          agenda.role_id = doc.data().role_id;
          agenda.role_name = doc.data().role_name;

          agendas.push(agenda);
        });
      });
      return agendas;
    } catch (error) {
      console.error("Erro ao buscar agendas: ", error);
      throw error; // Lançar o erro para que ele possa ser tratado por quem chamou o método
    } finally {
      waiting.close();
    }

  }

  async formatAgenda (agendaRaw: any[]) {
    const waiting = this._spinnerService.show();
    try {
      let arrayAgenda = agendaRaw;

      arrayAgenda.forEach((ag) => {
        if (ag.level == "a") {
          //atividades
          let activities: any = arrayAgenda.filter((e) => {
            return e.activity_id == ag.activity_id
          })

          //equipe da atividade
          ag.activityStaff = []
          activities.forEach(el => {
            if (el.level == 'a') {
              ag.activityStaff.push({
                'role_name': el.role_name,
                'member_name': el.member_name
              })
            }
          });

          //tópicos da atividade
          ag.activityTopics = []
          activities.forEach(el => {
            if (el.topic_name) {
              let exist = ag.activityTopics.find((e) => {
                return e.topic_name == el.topic_name && e.topic_startTime == el.topic_startTime
              })
              if (!exist) {
                ag.activityTopics.push({
                  'topic_startTime': el.topic_startTime,
                  'topic_name': el.topic_name
                })
              }
            }
          });
          ag.activityTopics.sort(this.compareTimes)

        } else if (ag.level == "t") {
          //tópicos
          let topics: any = arrayAgenda.filter((e) => {
            return e.topic_id == ag.topic_id
          })
          //equipe do tópico
          ag.topicStaff = []
          topics.forEach(el => {
            if (el.level == 't') {
              ag.topicStaff.push({
                'role_name': el.role_name,
                'member_name': el.member_name
              })
            }
          });
        }
      })
      return arrayAgenda;
    } catch (error) {
      console.error("Error formatAgenda: ", error);
      throw error;
    } finally {
      waiting.close();
    }
  }

  async loadAndCheckInvitesSent (context_id: any, letter_id: any, agendaByMembers: any[]) {
    const waiting = this._spinnerService.show();
    try {
      return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
        .where('context_id', '==', context_id)
        .where('letter_id', '==', letter_id))
        .snapshotChanges()
        .subscribe(async (result) => {
          const invites: any[] = [];
          result.forEach(async (item) => {
            let dt_sent: any = item.payload.doc.data().date_sent
            let dt_response: any = item.payload.doc.data().date_response
            let entity: any = {
              'id': item.payload.doc.id,
              'event_id': item.payload.doc.data().event_id,
              'letter_id': item.payload.doc.data().letter_id,
              'member_id': item.payload.doc.data().member_id,
              'accept': item.payload.doc.data().accept,
              'date_sent': dt_sent ? new Date(dt_sent.seconds * 1000) : null,
              'date_response': dt_response ? new Date(dt_response.seconds * 1000) : null,
              'obs': item.payload.doc.data().obs,
              'admin_invite': item.payload.doc.data().admin_invite,
              'admin_response': item.payload.doc.data().admin_response,
              'url_back': item.payload.doc.data().url_back,
              'agenda': item.payload.doc.data().agenda
            }
            invites.push(entity)
          })
          return await this.checkSentInvites(invites, agendaByMembers)
        })

    } catch (error) {
      console.error("Error getInvitesSent: ", error);
      throw error;
    } finally {
      waiting.close();
    }
  }

  async checkSentInvites (invites: any[], agenda: any[]) {
    const waiting = this._spinnerService.show();
    const array: any[] = []
    try {
      agenda.forEach(async (item) => {
        const inviteExist = invites.find((e) => {
          return e.member_id == item.member_id
        })
        const confirmTrue = item.agenda.find((e: any) => {
          return e.requireConfirm == true
        })
        const requireConfirmAll = confirmTrue ? true : false;

        let inviteSent: any = {}
        inviteSent.member_id = item.member_id;
        inviteSent.member_name = item.member_name;
        inviteSent.requireConfirmAll = requireConfirmAll;
        //

        if (inviteExist) {
          inviteSent.invite_id = inviteExist.id;
          inviteSent.date_sent = inviteExist.date_sent;
          inviteSent.date_response = inviteExist.date_response;
          inviteSent.url_back = inviteExist.url_back;
          inviteSent.accept = inviteExist.accept;
          inviteSent.admin_invite = inviteExist.admin_invite;
          inviteSent.admin_response = inviteExist.admin_response;
          inviteSent.obs = inviteExist.obs;
          inviteSent.agenda = inviteExist.agenda;

        } else {
          inviteSent.invite_id = null;
          inviteSent.date_sent = null;
          inviteSent.date_response = null;
          inviteSent.url_back = null;
          inviteSent.accept = null;
          inviteSent.admin_invite = null;
          inviteSent.admin_response = null;
          inviteSent.obs = null;

          item.agenda.sort(this.compareDays)
          inviteSent.agenda = item.agenda;
        }

        array.push(inviteSent)

      })
      array.sort(this.compareNames);

      this.invitesDataSource = new MatTableDataSource(array);
      return;
    } catch (error) {
      console.error("Error checkSentInvites: ", error);
      throw error;
    } finally {
      waiting.close();
    }
  }

  async groupByMemberId (originalArray: any[]) {
    const waiting = this._spinnerService.show();
    try {
      const groupedMap = new Map();

      originalArray.forEach(item => {
        if (!groupedMap.has(item.member_id)) {
          groupedMap.set(item.member_id, {
            member_id: item.member_id,
            member_name: item.member_name,
            agenda: []
          });
        }
        groupedMap.get(item.member_id).agenda.push(item);
      });
      return Array.from(groupedMap.values());
    } catch (error) {
      console.error("Error getInvitesSent: ", error);
      throw error;
    } finally {
      waiting.close();
    }
  }

  compareTimes (a, b) {
    let pa: string = a.topic_startTime;
    let pb: string = b.topic_startTime;
    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;
  }

  compareDays (a: any, b: any) {
    let pa: string = a.day_date;
    let pb: string = b.day_date;
    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;
  }

  compareNames (a: any, b: any) {
    let pa: string = a.member_name;
    let pb: string = b.member_name;
    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_invites_v2').doc(entity_id).delete();
  }

  makeShipping (invites: any, letter: any, context_id: any) {

    if (invites) {
      //console.log("invies: " + JSON.stringify(invites))

      invites.forEach((item) => {

        if (item.selected) { //&& !data.sent
          let invite: any = {}
          invite = item;
          // context_id
          // se for congresso o contexto é o contexto do congresso, ex: 50º Congresso
          // se for evento o contexto é o id do evento 
          // invite.context_id = context_id;
          // console.log("invite.member_name: " + invite.member_name)

          const data: any = {
            'letter': letter,
            'context_id': context_id,
            'invite': invite
          }

          // console.log("invite data: " + JSON.stringify(data))
          this.registerInvite(data, true, "", false);

        }

      })
    }
  }

  registerInvite (data: any, useEmail: boolean, obs: string, admin_invite: boolean): Promise<any> {

    return new Promise((resolve, reject) => {
      return this.db.doc<Member>('sbccv_members/' + data.invite.member_id)
        .get()
        .subscribe((member) => {

          let memberTemp: any = {};
          const email_crypto = this._cryptoService.set(this._cryptoService.key, member.data().email)
          const phone_crypto = this._cryptoService.set(this._cryptoService.key, member.data().cellPhone)
          const cpf_crypto = this._cryptoService.set(this._cryptoService.key, member.data().cpf)

          memberTemp = {
            'name': member.data().name,
            'email': email_crypto,
            'cellPhone': phone_crypto,
            'cpf': cpf_crypto,
            'text': member.data().text,
            'image': member.data().image,
            'imageChanged': false,
            'dateCreated': new Date(),
            'moved': false,
            'updated': false,
            'changed': false,
          }

          let url_back: string = this.makeURL(data);
          let html_email: string = this.makeEmail(data.invite, data.letter, url_back);
          let member_email = email_crypto//member.data().email
          let newInvite: InviteV2 = this.makeInvite(data, url_back, member_email, html_email, obs, admin_invite, memberTemp);

          let p_agenda: any[] = []

          newInvite.agenda.forEach((item) => {
            p_agenda.push(Object.assign({}, item))
          })
          p_agenda.sort(this.compareDays)
          newInvite.agenda = p_agenda

          
          return this.db.collection('sbccv_invites_v2').add(Object.assign({}, newInvite))
            .then((result) => {
              console.log("convite registrado")
              newInvite.id = result.id
              if (useEmail) {
                this.sendEmail(newInvite)
              }
              resolve(newInvite)
            })
            .catch((error) => {
              console.log("ERRO " + JSON.stringify(error.message));
              reject(error)
            })
              

        })
    })
  }

  async sendEmail (invite: any) {

    let email_plain = this._cryptoService.get(this._cryptoService.key, invite.member_email)

    // console.log("sendEmail member_name: " + invite.member_name)
    // console.log("sendEmail member_email: " + email_plain)
    // console.log("sendEmail letter_text: " + invite.letter_text)
    // console.log("-------------------------------------")

  
    try {
      await this._emailService.sendStandardEmail({
        'subject': invite.letter_subject,
        'html': invite.letter_text,
        'from': "SBCCV <cientifico@sbccv.org.br>",
        'to': email_plain,
        'bcc': "cientifico@sbccv.org.br"
      });
    } catch {
      console.log("send email error");
    }
  

  }

  makeURL (data: any) {

    const invite = data.invite
    const letter = data.letter
    const context_id = data.context_id

    let url_typed: string;

    if (letter.type == '0') { // confirmação
      url_typed = "https://sbccv-proj.firebaseapp.com/speaker-confirm-back/"
    } else if (letter.type == '1') {// atualizar
      url_typed = "https://sbccv-proj.firebaseapp.com/speaker-update-back/"
    }

    let url_back: any = ""
    url_back += url_typed
    url_back += invite.member_id + ":"
    url_back += letter.id + ":"
    url_back += letter.event_id;

    return url_back;
  }

  makeEmail (invite: any, letter: any, url_back: string) {

    // console.log("makeEmail letter.type : " + letter.type )

    let link_resposta = ""
    link_resposta += "<a href='" + url_back + "'>";

    if (letter.type == '0') {
      link_resposta += "Clique aqui para registrar sua resposta.";
    } else if (letter.type == '1') {
      link_resposta += "Clique aqui para revisar seus dados.";
    }

    link_resposta += "</a>";

    let resumo_atividade: string = "";

    invite.agenda.forEach(appointment => {

      resumo_atividade += "<ul>";

      resumo_atividade += "<div>";
      resumo_atividade += "<span>" + appointment.role_name + "</span>";
      if (appointment.level == 't') {
        resumo_atividade += "<span> no tópico</span>";
      } else if (appointment.level == 'a') {
        resumo_atividade += "<span> na atividade</span>";
      }
      resumo_atividade += "</div>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Data: </div>";
      resumo_atividade += "<div>" + appointment.day_date_string + "</div>";
      resumo_atividade += "</li>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Departamento: </div>";
      resumo_atividade += "<div>" + appointment.depto_name + "</div>";
      resumo_atividade += "</li>";

      resumo_atividade += "<li>";
      resumo_atividade += "<div>Atividade: </div>";
      resumo_atividade += "<div>" + appointment.activity_startTime + " - " + appointment.activity_name + "</div>";
      resumo_atividade += "</li>";

      if (appointment.level == 't') {

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Tópico: </div>";
        resumo_atividade += "<div>" + appointment.topic_startTime + " - " + appointment.topic_name + "</div>";
        resumo_atividade += "<div>" + appointment.topic_duration + " minutos" + "</div>";
        resumo_atividade += "</li>";

        resumo_atividade += "<li>";
        resumo_atividade += "<div>Equipe do Tópico</div>"

        appointment.topicStaff.forEach(st => {
          resumo_atividade += "<div style='margin-left:20px;'>";
          if (invite.member_name == st.member_name) {
            resumo_atividade += st.role_name + " - " + "<span style='color:rgb(0,0,220);'>" + st.member_name + "</span>";
          } else {
            resumo_atividade += st.role_name + " - " + st.member_name;
          }
          resumo_atividade += "</div>";
        });
        resumo_atividade += "</li>";

        resumo_atividade += "<hr>";
      }


      if (appointment.level == 'a') {
        resumo_atividade += "<ul>";
        resumo_atividade += "<div>Equipe da atividade</div>";

        appointment.activityStaff.forEach(st => {
          resumo_atividade += "<li>";
          if (invite.member_name == st.member_name) {
            resumo_atividade += st.role_name + " - " + "<span style='color:rgb(0,0,220);'>" + st.member_name + "</span>";
          } else {
            resumo_atividade += st.role_name + " - " + st.member_name;
          }
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";

        resumo_atividade += "<hr>";

        resumo_atividade += "<ul>"
        appointment.activityTopics.forEach(ac => {
          resumo_atividade += "<li>";
          resumo_atividade += ac.topic_startTime + " - " + ac.topic_name;
          resumo_atividade += "</li>";
        });
        resumo_atividade += "</ul>";
      }

      resumo_atividade += "</ul>";
    });

    // realiza as substituições das tgs pelos seus valores reais
    let temp_text = letter.text;

    if (letter.imageTop) {
      temp_text = temp_text.replace('[imagem_1]', "<img src='" + letter.imageTop + "'>")
    }
    else {
      temp_text = temp_text.replace('[imagem_1]', "")
    }

    if (letter.imageBottom) {
      temp_text = temp_text.replace('[imagem_2]', "<img src='" + letter.imageBottom + "'>")
    } else {
      temp_text = temp_text.replace('[imagem_2]', "")
    }

    if (letter.imageBody) {
      temp_text = temp_text.replace('[imagem_corpo]', "<img src='" + letter.imageBody + "'>")
    } else {
      temp_text = temp_text.replace('[imagem_corpo]', "")
    }

    temp_text = temp_text.replace('[nome_associado]', invite.member_name)
    temp_text = temp_text.replace('[link_resposta]', link_resposta)
    temp_text = temp_text.replace('[resumo_atividade]', resumo_atividade)

    return "<div style='font-family: Helvetica, Arial; width: 800px;'>" + temp_text + "</div>";

  }

  makeInvite (data: any, url_back: string, member_email: string, html_email: string, obs: string, admin_invite: boolean, memberDataCheck: any = null) {

    const letter: any = data.letter
    //const event: any = data.event
    const invite: any = data.invite

    let entity: InviteV2 = new InviteV2();
    entity.letter_id = letter.id;
    entity.letter_name = letter.name;
    entity.letter_subject = letter.subject;
    entity.letter_text = html_email;
    entity.event_id = letter.event_id;
    entity.event_name = letter.event_name;
    entity.context_id = data.context_id;
    entity.member_id = invite.member_id;
    entity.member_name = invite.member_name;

    entity.member_email = member_email; // pode não existir e é por isso que tá registrando sem enviar email
    entity.date_sent = new Date();
    entity.date_response = null;
    entity.accept = false;
    entity.obs = obs;
    entity.admin_invite = admin_invite;
    entity.admin_response = false;

    entity.url_back = url_back;
    entity.type = letter.type;
    entity.agenda = invite.agenda;
    entity.memberDataCheck = memberDataCheck;

    return entity;
  }

  formatDate (_date: any) {
    // console.log(date)
    if (_date) {

      let date = new Date(_date.seconds * 1000)
      let dt = date.toISOString()

      let dd: any = dt.substring(8, 10);
      let mm: any = dt.substring(5, 7);
      let yy: any = dt.substring(0, 4);
      const dtReturn = dd + "/" + mm + "/" + yy;

      return dtReturn;
    } else {
      return ""
    }
  }

  selectByInvite (member_id, letter_id, event_id) {
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where('member_id', '==', member_id)
      .where('letter_id', '==', letter_id)
      .where('event_id', '==', event_id)
    ).get();
  }

  selectByInviteAndContext (member_id, letter_id, context_id) {
    return this.db.collection<InviteV2>('sbccv_invites_v2', ref => ref
      .where('member_id', '==', member_id)
      .where('letter_id', '==', letter_id)
      .where('context_id', '==', context_id)
    ).get();
  }

  archiveInvite (id: string, flag: boolean) {
    return this.db.collection('sbccv_invites_v2').doc(id).update({'archived': !flag});
  }

}